import { render, staticRenderFns } from "./PecaEstudanteUserForm.vue?vue&type=template&id=9266927a"
import script from "./PecaEstudanteUserForm.vue?vue&type=script&lang=js"
export * from "./PecaEstudanteUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports